// Utils
import { AI_TRANSLATION_LANGUAGES } from "@toddle-edu/common-utils";

export const PROMPT_TYPES = {
  TEXT_TOOL_EVALUATION: "TEXT_TOOL_EVALUATION",
  NON_TEXT_TOOL_EVALUATION: "NON_TEXT_TOOL_EVALUATION",
};

export const AI_PROMPTS_ACTION_MAPPING = {
  AI_CAPTION_FILLED: "ai_caption_filled",
  TRANSLATE: "translate",
  DEFAULT_LANGUAGE: "default_language",
};

export const AI_GENERATE_ACTIONS_MAPPING = {
  SHORTEN: "shorten",
  ELABORATE: "elaborate",
  FIX_SPELLING_GRAMMAR: "check_for_spelling_and_grammar",
  SIMPLIFY_LANGUAGE: "simplify_writing",
  IMPROVE_LANGUAGE: "improve_writing",
  REGENERATE: "regenerate",
};

export const LANGUAGE_ACTIONS = AI_TRANSLATION_LANGUAGES;
